// Builds the Google OAuth authorize URL and starts the full-page redirect.
// No popup, no postmessage — the user lands back at `${origin}/auth/google?code=...`.
//
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleRedirect(returnTo) {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  if (!clientId) {
    throw new Error('Missing REACT_APP_GOOGLE_CLIENT_ID');
  }
  const redirectUri = window.location.origin + '/auth/google';
  const state = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem('google_auth_state', state);
  if (returnTo) sessionStorage.setItem('google_auth_return_to', returnTo);

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'openid email profile',
    access_type: 'online',
    include_granted_scopes: 'true',
    prompt: 'select_account',
    state,
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}
